import { render, staticRenderFns } from "./BottomNavDrawer.vue?vue&type=template&id=65dcccde&scoped=true"
import script from "./BottomNavDrawer.vue?vue&type=script&lang=js"
export * from "./BottomNavDrawer.vue?vue&type=script&lang=js"
import style0 from "./BottomNavDrawer.vue?vue&type=style&index=0&id=65dcccde&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dcccde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65dcccde')) {
      api.createRecord('65dcccde', component.options)
    } else {
      api.reload('65dcccde', component.options)
    }
    module.hot.accept("./BottomNavDrawer.vue?vue&type=template&id=65dcccde&scoped=true", function () {
      api.rerender('65dcccde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/advertising/components/BottomNavDrawer.vue"
export default component.exports